import type React from 'react';
import SkeletonComponent, {type SkeletonProps} from '@mui/material/Skeleton';

type Props = Pick<SkeletonProps, 'width' | 'height' | 'animation' | 'variant'>;

export const Skeleton = SkeletonComponent as React.ComponentType<Props>;
